import i18n from "@/i18n"

export function useDaysFormatter() {
  const dayKeys: { [key: string]: string } = {
    1: 'dayShortMon',
    2: 'dayShortTue',
    3: 'dayShortWed',
    4: 'dayShortThu',
    5: 'dayShortFri',
    6: 'dayShortSat',
    7: 'dayShortSun'
  }

  const dayLabel = (n: number): string => {
    const key = dayKeys[n]
    return key ? i18n.global.t(key) : ''
  }

  const formatDays = (days: string[]): string => {
    const sortedDays = days.map((day) => parseInt(day)).sort((a, b) => a - b)

    const hasConsecutiveDays = (): boolean => {
      return sortedDays.every((day, index) => {
        if (index === 0) return true
        return day === sortedDays[index - 1] + 1
      })
    }
    const isConsecutive = hasConsecutiveDays()

    const resultDay = isConsecutive
      ? `${dayLabel(sortedDays[0])} - ${dayLabel(sortedDays[sortedDays.length - 1])}`
      : sortedDays.map((jour) => dayLabel(jour)).join(', ')

    return resultDay
  }

  return {
    formatDays
  }
}
